import { useEffect } from 'react';
import { userAppContext } from '@/context/Context';
import { useDiseaseVocabularyCodesStore } from '@/store/diseaseVocabularyCodesStore';
import { DISEASE_VOCABULARY_LINKS } from '../config/constants';

type VocabularyCodeCellProps = {
  data: any;
  vocabulary: string;
};

export function VocabularyCodeCell({ data, vocabulary }: VocabularyCodeCellProps) {
  const { authorization, isAuthenticated } = (userAppContext() as any) ?? {};
  const diseaseUMLSCUI = data?.diseaseUMLSCUI;
  const entry = useDiseaseVocabularyCodesStore(state =>
    diseaseUMLSCUI ? state.entries[diseaseUMLSCUI] : undefined,
  );
  const fetchDiseaseCodes = useDiseaseVocabularyCodesStore(state => state.fetchDiseaseCodes);

  useEffect(() => {
    if (!diseaseUMLSCUI) return;
    fetchDiseaseCodes(diseaseUMLSCUI, authorization, Boolean(isAuthenticated));
  }, [diseaseUMLSCUI, authorization, isAuthenticated, fetchDiseaseCodes]);

  if (!diseaseUMLSCUI) return <span>-</span>;
  if (!entry || entry.status === 'loading') return <span className="text-muted">…</span>;
  if (entry.status === 'error') return <span>-</span>;

  const matches = entry.codes.filter(code => code.vocabulary === vocabulary);
  if (matches.length === 0) return <span>-</span>;

  const link = DISEASE_VOCABULARY_LINKS[vocabulary];

  return (
    <>
      {matches.map((code, index) => {
        const cleanedUpCode = String(code.code).replaceAll('.', '');
        const href = link ? `${link}${cleanedUpCode}` : undefined;
        return (
          <span key={`${vocabulary}-${code.code}-${index}`} title={code.name}>
            {href ? (
              <a href={href} className="mapId" target="_blank" rel="noreferrer">
                {code.code}
              </a>
            ) : (
              code.code
            )}
            {index < matches.length - 1 && ', '}
          </span>
        );
      })}
    </>
  );
}
